
import "/home/builduser/work/3c6b853c37b1ced8/packages/common/client-common/src/wix-colors/wix-colors.st.css";
import "/home/builduser/work/3c6b853c37b1ced8/packages/projects/doppe/doppe-ui/src/doppe-colors/doppe-colors.st.css";
import "/home/builduser/work/3c6b853c37b1ced8/packages/projects/doppe/doppe-ui/src/doppe-typography/doppe-typography.st.css";
export const namespace = /* INJECT */ {__namespace__:true};
export const classes = /* INJECT */ {__classes__:true};
export const keyframes = /* INJECT */ {__keyframes__:true}; 
export const layers = /* INJECT */ {__layers__:true};
export const containers = /* INJECT */ {__containers__:true};
export const stVars = /* INJECT */ {__stVars__:true}; 
export const vars = /* INJECT */ {__vars__:true}; 
export const cssStates = /* INJECT */ {__stc__:true};
export const style = /* INJECT */ {__sts__:true};
export const st = /* INJECT */ {__st__:true};
/* JS_INJECT */
if(import.meta.webpackHot /* HMR */) { import.meta.webpackHot.accept();}
